export default {
  saveRef: function saveRef(name) {
    var _this = this;

    return function (node) {
      _this[name] = node;
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tabs/es/RefMixin.js
// module id = null
// module chunks = 